import React, { Component } from 'react';
import { DatePicker, Button } from 'antd';
import SearchInput from '../../common/SearchInput';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';

const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;

class Filter extends Component {
    state = {
        loading: false,
        searchParams: {
            inspectionTime: null,
        },
        userOptions: [],
        maxMonth: '',
    }

    componentDidMount() {
        const { curRole } = sessionStorage;
        (curRole == 'BO' || curRole == 'CTA') ? this.queryDate() : this.search();
    }

    queryDate = () => {
        const options = {
            url: API_URL.hospital.querySsuMemberScoreGradeDate,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { date } = res;
                const { searchParams } = this.state;
                searchParams.inspectionTime = date;
                const maxMonth = date;
                this.setState({
                    maxMonth,
                    searchParams
                }, () => {
                    this.search();
                });
            },
        };
        $.sendRequest(options);
    }

    // 员工
    userSelectChange = value => {
        const { searchParams } = this.state;
        if (value == undefined) {
            searchParams.userId = '';
        } else {
            searchParams.userId = value.key;
        }
        this.setState({ searchParams });
    }

    parseUserData = (res, value) => {
        if ((res.data || res.datas) ) {
            const sourceData = res.datas;
            const data = sourceData.map(item => ({
                text: `${item.userCompellation}[${item.employeeCode}]`,
                value: item.userId,
            }));
            this.setState({ userOptions: data });
        } else {
            this.setState({ userOptions: [] });
        }
    }
    
    onStartChange = (data, dateString) => {
        const { searchParams } = this.state;
        searchParams.inspectionTime = dateString;
        this.setState({ searchParams });
    }

    disabledDate = (current) => {
        const { maxMonth } = this.state;
        return current && current.valueOf() > moment(maxMonth).valueOf();
    }

    search = () => {
        const { searchParams } =  this.state;
        this.props.search(searchParams);
    }

    export = () => {
        this.props.export();
    }

    render() {
        const { curRole } = sessionStorage;
        const { canSynchronize, synchronizeUser } = this.props;
        const { userOptions, searchParams: { inspectionTime } } = this.state;
        const newInspectionTime = inspectionTime ? moment(inspectionTime) : null;
        const isBO = curRole == 'BO';
        const isCTA = curRole == 'CTA';
        return (
            <div className="filter-bar">
                <div className="form-item">
                    <label className="ui-label">考核时间</label>
                    <MonthPicker
                        style={{width:90}}
                        format={monthFormat}
                        value={newInspectionTime}
                        allowClear={!(isBO || isCTA)}
                        placeholder="请选择"
                        disabledDate={this.disabledDate}
                        onChange={this.onStartChange}
                        className="w-90-select"
                    />
                </div>
                {
                    (isBO || isCTA) &&
                    <div className="form-item">
                        <label className="ui-label">SSU人员</label>
                        <SearchInput
                            name="user"
                            style={{ width: 162 }}
                            url={API_URL.investigation.queryUserByKey}
                            keyword='keyword'
                            dataSource={userOptions}
                            parseData={this.parseUserData}
                            handleSelect={this.userSelectChange}
                            placeholder='请输入姓名/工号自动检索'
                        />
                    </div>
                }
                <div className="form-item">
                    { (isBO || isCTA) && <Button type="primary" onClick={this.export}>导出</Button> }
                    {
                        isBO &&
                        (
                            canSynchronize ?
                                <Button type="primary" onClick={synchronizeUser} style={{ background: '#62cf96', border: '1px solid #00a854' }}>同步人员</Button>
                            :
                                <Button disabled={true}>同步人员</Button>
                        )
                    }
                    <Button type="primary" onClick={this.search}>搜索</Button>
                </div>
            </div>
        );
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/hospital/StaffScore/Filter.js